// import { firebase } from './db';
import { Timestamp } from "firebase/firestore/lite";

export const characterLimit = 1000;
export const characterLimitDisplay = characterLimit - 50; // show warning on char limit after hitting this value

export function createReviewId(episodeId, userUID) {
    return episodeId + '_userId_' + userUID;
}

export function createReview({ rating, privacyType, comment, edit = false }) {
    const reviewObj = {
        rating: rating,
        comment: comment || '',
        commentLength: comment ? comment.length : 0,
        lastModifiedDate: Timestamp.fromDate(new Date()), // FieldValue.serverTimestamp(),
        // isPrivate: isPrivate || true,
        privacyType: privacyType || 'private',
    };
    if (edit != true) {
        reviewObj['postedDate'] = Timestamp.fromDate(new Date()); // firebase.firestore.FieldValue.serverTimestamp(),
    }

    return reviewObj;
}

export function sortEpisodeReviews(a, b) {
    if (a.commentLength > b.commentLength) return -1;
    if (a.commentLength < b.commentLength) return 1;

    if (a.rating > b.rating) return -1;
    if (a.rating < b.rating) return 1;

    if (a.lastModifiedDate > b.lastModifiedDate) return -1;
    if (a.lastModifiedDate < b.lastModifiedDate) return 1;
    // return a.collectionName.localeCompare(b.collectionName);
}
